import React from "react";
import increaseRevenueIcon from "../../assets/increase_revenue.png";
import reduceCostIcon from "../../assets/reduce_cost.png";
import noChargeIcon from "../../assets/no_charge.png";
import fullAccessIcon from "../../assets/full_access.png";
import improveRetentionIcon from "../../assets/improve_retention.png";
import setupIn5Icon from "../../assets/setup_in_5.png";

const ALL_BADGES = [
  { key: "increase_revenue", icon: increaseRevenueIcon, text: "increase revenue by 3%-5%", style: { backgroundColor: "#FF4044" } },
  { key: "reduce_cost",      icon: reduceCostIcon,      text: "reduce cost by 30%",        style: { backgroundColor: "#FF4044" } },
  { key: "no_charge",        icon: noChargeIcon,        text: "no charge first 30 days",   style: { backgroundColor: "rgba(255,145,20,0.42)", border: "1px solid #FF9114" } },
  { key: "full_access",      icon: fullAccessIcon,      text: "full access to all features",style: { backgroundColor: "#FF9114" } },
  { key: "improve_retention",icon: improveRetentionIcon,text: "improve customer retention", style: { backgroundColor: "#FF9114" } },
  { key: "setup_in_5",       icon: setupIn5Icon,        text: "setup in under 5 minutes",  style: { backgroundColor: "#FF9114" } },
];

const DatapointBadges = ({ keys, className = "" }) => {
  const badges = keys ? ALL_BADGES.filter((b) => keys.includes(b.key)) : ALL_BADGES;

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {badges.map((badge) => (
        <div
          key={badge.key}
          className="flex items-center gap-2 text-white text-sm font-medium px-4 py-2.5 rounded-full whitespace-nowrap overflow-visible"
          style={badge.style}
        >
          <img src={badge.icon} alt={badge.text} className="w-7 h-7 object-contain shrink-0 my-[-4px]" />
          <span>{badge.text}</span>
        </div>
      ))}
    </div>
  );
};

export default DatapointBadges;
